import * as Sentry from '@sentry/react';
import jwtDecode from 'jwt-decode';
import Cookies from 'universal-cookie';

import { UserType } from './types';

// Types
export type DecodedAuthToken = {
  id: string;
  userType: UserType;
  email: string;
};

// Constants
const AUTH_TOKEN_NAME = 'accessToken';
export const AUTH_CHANGE_TRIGGER = 'authChangeTrigger';

// Helpers
const getAuthTokenUnsafe = () => {
  return (new Cookies().get(AUTH_TOKEN_NAME) as string | undefined) ?? null;
};
const getAuthTokenOrThrow = () => {
  const token = getAuthTokenUnsafe();
  if (!token) throw Error('Missing auth token');
  return token;
};
const getDecodedTokenUnsafe = () => {
  const token = getAuthTokenUnsafe();
  return token ? jwtDecode<DecodedAuthToken>(token) : null;
};
const getDecodedTokenOrThrow = () => {
  const token = getAuthTokenOrThrow();
  return jwtDecode<DecodedAuthToken>(token);
};
const setAuthToken = (newToken: string) => {
  window.localStorage.setItem(AUTH_CHANGE_TRIGGER, new Date().toISOString());
  return new Cookies().set(AUTH_TOKEN_NAME, newToken, { path: '/' });
};
const removeAuthToken = () => {
  Sentry.configureScope((scope) => scope.setUser(null));
  window.localStorage.setItem(AUTH_CHANGE_TRIGGER, new Date().toISOString());
  return new Cookies().remove(AUTH_TOKEN_NAME, { path: '/' });
};

// Exports
export {
  getAuthTokenUnsafe,
  getAuthTokenOrThrow,
  getDecodedTokenUnsafe,
  getDecodedTokenOrThrow,
  setAuthToken,
  removeAuthToken,
};
